// /var/www/aesirerp_lp/frontend/src/components/hero/IntroAnimation.tsx
'use client';

import { useEffect, useState } from 'react';
import styles from './IntroAnimation.module.css';
import { useLanguage } from '@/contexts/LanguageContext';

export function IntroAnimation() {
  const { t } = useLanguage();
  const prefix = t('intro.prefix') as string;
  const words = t('intro.words') as string[];

  const [wordIndex, setWordIndex] = useState(0);
  const [isRendered, setIsRendered] = useState(true);

  useEffect(() => {
    const wordInterval = setInterval(() => {
      setWordIndex((prev) => {
        if (prev < words.length - 1) {
          return prev + 1;
        }
        clearInterval(wordInterval);
        return prev;
      });
    }, 650);

    const unmountTimeout = setTimeout(() => {
      setIsRendered(false);
    }, 4200);

    return () => {
      clearInterval(wordInterval);
      clearTimeout(unmountTimeout);
    };
  }, [words.length]);

  if (!isRendered) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.textContainer}>
        <span className={styles.staticText}>{prefix}</span>
        <div className={styles.dynamicTextWrapper}>
          <span key={wordIndex} className={styles.dynamicWord}>
            {words[wordIndex]}
          </span>
        </div>
      </div>
    </div>
  );
}